import { v4 as uuid } from 'uuid';

interface WindowWithGA extends Window {
    GoogleAnalyticsObject?: any;
    DIDataLayer?: any;
}
declare var window: WindowWithGA;

class LocationStorageManager {
    private static instance: LocationStorageManager;
    private storageAvailable = false;

    // data specific to a guid
    private keyName: string;
    private data: any = {};
    private defaults = {
        sessionStarted: new Date().toISOString(),
        gaClientId: this.getGoogleAnalyticsVisitorId(),
        roxanneVisitorId: this.getRoxanneVisitorId(),
    };

    // data shared among all guids
    private sharedKeyName = 'Conversations';
    private sharedData: any = {};
    private sharedDefaults = {
        senderId: uuid(),
    };

    private constructor(guid: string) {
        if (LocationStorageManager.instance) return LocationStorageManager.instance;

        this.keyName = `Conversations_${guid}`;

        this.storageAvailable = this.isLocalStorageAvailable();

        // load guid-specific data
        const storedData = this.loadfromStorage(this.keyName);
        this.data = { ...this.defaults, ...storedData };

        // load shared data
        const storedSharedData = this.loadfromStorage(this.sharedKeyName);
        this.sharedData = { ...this.sharedDefaults, ...storedSharedData };

        // save to LS
        this.saveToStorage();

        // create singleton
        LocationStorageManager.instance = this;
        return LocationStorageManager.instance;
    }

    public static create(guid: string) {
        return new LocationStorageManager(guid);
    }

    public getData() {
        return { ...this.sharedData, ...this.data };
    }

    public addData(newData: any) {
        this.data = { ...this.data, ...newData };
        this.saveToStorage();
        return this;
    }

    public addSharedData(newData: any) {
        this.sharedData = { ...this.sharedData, ...newData };
        this.saveToStorage();
        return this;
    }

    public resetSenderId() {
        this.sharedData.senderId = uuid();
        return this;
    }

    private isLocalStorageAvailable(): boolean {
        try {
            let storage = window.localStorage;
            let x = '__storage_test__';
            storage.setItem(x, x);
            storage.removeItem(x);
            return true;
        } catch (e) {
            return false;
        }
    }

    private loadfromStorage(keyName: string) {
        if (!this.storageAvailable) return {};

        try {
            const raw = localStorage.getItem(keyName);
            if (raw) {
                return JSON.parse(raw);
            }
        } catch (e) {
            // ignore
        }

        return {};
    }

    private saveToStorage() {
        if (!this.storageAvailable) return;

        try {
            localStorage.setItem(this.keyName, JSON.stringify(this.data));
            localStorage.setItem(this.sharedKeyName, JSON.stringify(this.sharedData));
        } catch (e) {
            // ignore
        }
    }

    private getRoxanneVisitorId(): string | void {
        if (
            window.DIDataLayer &&
            window.DIDataLayer.user &&
            typeof window.DIDataLayer.user.get === 'function' &&
            window.DIDataLayer.user.get().visitor_id
        ) {
            return String(window.DIDataLayer.user.get().visitor_id);
        }
    }

    private getGoogleAnalyticsVisitorId(): string | void {
        let clientId;

        if (window.GoogleAnalyticsObject) {
            var gaName = window.GoogleAnalyticsObject;
        }
        if (gaName && window[gaName]) {
            window[gaName](function(tracker: any) {
                if (!tracker) {
                    // site is not using a default tracker
                    // client_id is the same for all trackers so just use the first one
                    tracker = window[gaName].getAll()[0];
                }
                clientId = tracker.get('clientId');
            });
        }

        return clientId;
    }
}

export let instance: LocationStorageManager;

export function init(guid: string): LocationStorageManager {
    instance = LocationStorageManager.create(guid);
    return instance;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/util/LocalStorageManager.ts